function coerceBoolean(value) {
    // note: don't use isString for preserve circular dependencies
    return typeof value === 'string' ? value?.trim() === '' || value?.trim() !== 'false' : Boolean(value);
}

/**
 * Generated bundle index. Do not edit.
 */

export { coerceBoolean };
